import { render } from "./IconApps.vue?vue&type=template&id=3af0005b"
import script from "./IconApps.vue?vue&type=script&lang=js"
export * from "./IconApps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__